module.exports = "images/teamed_image_02.png";